"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cleanup = void 0;
const construciton_1 = require("./construciton");
/**
 * Close the ephemeral accounts such that the caller reclaims more rent then
 * is spent on the transaction of closing the account.
 *
 * As a note: this may mean that result accounts are not closed as they have next to
 * no rent
 */
const cleanup = (provider, mallocProgram, construction, constructionSigner, authority, options) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const recipient = (_a = options === null || options === void 0 ? void 0 : options.solRecipient) !== null && _a !== void 0 ? _a : provider.wallet.publicKey;
    const deleteConstructionTx = (0, construciton_1.closeConstructionAccount)(mallocProgram, constructionSigner.publicKey, recipient, authority);
    return [deleteConstructionTx];
});
exports.cleanup = cleanup;
